import React, { useState } from "react";
import { Modal, Input } from "antd";

interface AddIpModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { ip_address: string; description: string }) => void;
  loading?: boolean;
}

const AddIpModal: React.FC<AddIpModalProps> = ({
  open,
  onClose,
  onSubmit,
  loading,
}) => {
  const [ip, setIp] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = () => {
    if (!ip) return;

    onSubmit({
      ip_address: ip,
      description,
    });

    setIp("");
    setDescription("");
  };

  return (
    <Modal
      title="Add IP Address"
      open={open}
      onCancel={onClose}
      footer={null}
      closable={!loading}
      maskClosable={!loading}
    >
      <div className="flex flex-col gap-4">
        <Input
          size="large"
          placeholder="Enter IP Address"
          value={ip}
          onChange={(e) => setIp(e.target.value)}
        />

        <Input
          size="large"
          placeholder="Enter Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <button
          onClick={handleSubmit}
          disabled={loading}
          className={`w-full py-2 rounded-md text-white ${
            loading ? "bg-gray-400 cursor-not-allowed" : "bg-primary"
          }`}
        >
          {loading ? "Adding..." : "Add IP"}
        </button>
      </div>
    </Modal>
  );
};

export default AddIpModal;
